import React from 'react'
import PropTypes from 'prop-types'
import { CloseButton } from 'shared/UI/CloseButton'

const DialogHeader = ({title, onClose, themeColorHex}) => (
  <div className="form-header">
    <h1 style={{color: themeColorHex}}>{title}</h1>
    <CloseButton onClose={onClose} />
  </div>
)

DialogHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  themeColorHex: PropTypes.string.isRequired
}

export default DialogHeader
